<template>
  <div class="row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Data Inspection Element'">
        <template v-slot:preview>
          <b-row>
            <b-col md="12" class="mb-2">
              <b-button variant="outline-dark" @click="$router.push('/master/addinspectionplant')">
                <span class="svg-icon svg-icon-sm svg-icon-dark">
                  <i class="flaticon2-plus"></i>
                </span>
                Create
              </b-button>
              <b-button
                class="ml-2"
                variant="outline-success"
                @click="$router.push('/master/importinspectionplant')"
              >
                <span class="svg-icon svg-icon-sm svg-icon-success">
                  <i class="flaticon-upload"></i>
                </span>
                Import Excel
              </b-button>
            </b-col>
            <b-col md="12">
              <b-table
                head-variant="dark"
                bordered
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                stacked="lg"
                show-empty
                responsive
                @filtered="onFiltered"
                :busy="isBusy"
              >
                <template #thead-top="data">
                  <b-tr>
                    <b-th colspan="1"></b-th>
                    <b-th>
                      <b-form-input
                        id="filter-1"
                        size="sm"
                        @input="loadData"
                        v-model="search.nama_equipment"
                        type="search"
                        placeholder="Cari Nama Equipment..."
                      ></b-form-input>
                    </b-th>
                    <b-th>
                      <b-form-input
                        id="filter-2"
                        size="sm"
                        @input="loadData"
                        v-model="search.nama_part"
                        type="search"
                        placeholder="Cari Nama Part..."
                      ></b-form-input>
                    </b-th>
                    <b-th>
                      <b-form-input
                        id="filter-3"
                        size="sm"
                        @input="loadData"
                        v-model="search.method"
                        type="search"
                        placeholder="Cari Metode..."
                      ></b-form-input>
                    </b-th>
                    <b-th>
                      <b-form-input
                        id="filter-5"
                        size="sm"
                        @input="loadData"
                        v-model="search.damage_mechanism"
                        type="search"
                        placeholder="Cari Mekanisme Kerusakan..."
                      ></b-form-input>
                    </b-th>
                    <b-th>
                      <b-form-input
                        id="filter-4"
                        size="sm"
                        @input="loadData"
                        v-model="search.mode_kerusakan"
                        type="search"
                        placeholder="Cari Mode Kerusakan..."
                      ></b-form-input>
                    </b-th>
                    <b-th colspan="1"></b-th>
                  </b-tr>
                </template>

                <template #cell(no)="data">
                  {{ (currentPage - 1) * 10 + data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <div
                    class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1"
                    @click="data.toggleDetails"
                  >
                    <span class="svg-icon svg-icon-sm svg-icon-success">
                      <i class="flaticon-eye text-success"></i>
                    </span>
                  </div>
                  <div class="btn btn-icon btn-clean btn-sm btn-dropdown mr-1">
                    <span
                      class="svg-icon svg-icon-xl svg-icon-primary"
                      @click="
                        $router.push('/master/editinspectionplant/' + data.item.id_inspection_plant)
                      "
                    >
                      <i class="flaticon2-pen text-primary"></i>
                    </span>
                  </div>
                  <div class="btn btn-icon btn-clean btn-sm btn-dropdown mr-1">
                    <span class="svg-icon svg-icon-xl svg-icon-danger" @click="toDelete(data)">
                      <i class="flaticon2-trash text-danger"></i>
                    </span>
                  </div>
                </template>

                <template #row-details="data">
                  <b-card>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Nama Equipment :</b></b-col>
                      <b-col>{{ data.item.nama_equipment }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Nama Part :</b></b-col>
                      <b-col>{{ data.item.nama_part }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Metode :</b></b-col>
                      <b-col>{{ data.item.method }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Mekanisme Kerusakan :</b></b-col>
                      <b-col>{{ data.item.nama_damage_mechanism }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Mode Kerusakan :</b></b-col>
                      <b-col>{{ data.item.mode_kerusakan }}</b-col>
                    </b-row>

                    <span class="svg-icon svg-icon-sm svg-icon-dark" @click="data.toggleDetails">
                      <i class="flaticon-close text-dark"></i>
                    </span>
                  </b-card>
                </template>

                <template #table-busy>
                  <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col md="5">
              <b-pagination
                v-model="currentPage"
                @input="paginate"
                :total-rows="totalRows"
                :per-page="10"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
            <b-col md="5">
              <h4 class="float-right">
                Showing
                <span v-if="totalPerPage">1-{{ totalPerPage }}</span>
                <span v-else>0</span>

                of {{ totalRows }}
              </h4>
            </b-col>
          </b-row>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import ApiService from '@/core/services/api.service'

import * as moment from 'moment'
import 'moment/locale/id'

export default {
  data() {
    return {
      items: [],
      fields: [
        { key: 'no', label: 'No', sortable: true },
        { key: 'nama_equipment', label: 'Nama Equipment', sortable: true },
        { key: 'nama_part', label: 'Nama Part', sortable: true },
        { key: 'method', label: 'Metode', sortable: true },
        {
          key: 'nama_damage_mechanism',
          label: 'Mekanisme Kerusakan',
          sortable: true,
        },
        { key: 'mode_kerusakan', label: 'Mode Kerusakan', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      search: {
        nama_equipment: '',
        nama_part: '',
        method: '',
        mode_kerusakan: '',
        damage_mechanism: '',
      },
      totalRows: 0,
      totalPerPage: 0,
      currentPage: 1,

      show: true,
      isBusy: false,
      dialog: false,
    }
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Master', route: '' },
      { title: 'Inspection Element' },
    ])
  },
  created() {
    var self = this
    self.isBusy = true

    ApiService.get(
      '/master/inspectionplant?page=' +
        this.currentPage +
        '&nama_equipment=' +
        this.search.nama_equipment +
        '&nama_part=' +
        this.search.nama_part +
        '&method=' +
        this.search.method +
        '&mode_kerusakan=' +
        this.search.mode_kerusakan +
        '&damage_mechanism=' +
        this.search.damage_mechanism
    ).then(({ data }) => {
      if (data.status == 'ok') {
        self.items = data.data.data
        self.totalRows = data.data.total
        self.totalPerPage = data.data.data.length
        self.isBusy = false
      }
    })
  },
  methods: {
    moment: function(date) {
      moment.locale('id')
      return moment(date, 'YYYY-MM-DD LTS').format('dddd, LL')
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.loadData()
    },
    paginate() {
      this.loadData()
    },
    async loadData() {
      var self = this
      self.isBusy = true
      // let current_page = this.filter == '' ? this.currentPage:1
      await this.timeout(100)
      ApiService.get(
        '/master/inspectionplant?page=' +
          this.currentPage +
          '&nama_equipment=' +
          this.search.nama_equipment +
          '&nama_part=' +
          this.search.nama_part +
          '&method=' +
          this.search.method +
          '&mode_kerusakan=' +
          this.search.mode_kerusakan +
          '&damage_mechanism=' +
          this.search.damage_mechanism
      ).then(({ data }) => {
        if (data.status == 'ok') {
          self.items = data.data.data
          self.totalPerPage = data.data.data.length
          self.isBusy = false
        }
      })
    },
    toDelete(row) {
      var id = row.item.id_inspection_plant
      let self = this
      this.$confirm({
        auth: false,
        message: 'Anda yakin akan menghapus data tersebut?',
        button: {
          yes: 'Ya',
          no: 'Batal',
        },
        callback: confirm => {
          if (confirm) {
            ApiService.get('/master/inspectionplant/delete/' + id).then(({ data }) => {
              if (data.status == 'ok') {
                self.isBusy = true
                var interval1 = null
                var i = 0
                self.loadData()
                interval1 = setInterval(function() {
                  if (i == 0) {
                    self.totalRows--
                    self.makeToast('warning', 'Data berhasil dihapus')
                    self.isBusy = false
                  } else {
                    clearInterval(interval1)
                  }
                  i++
                }, 1000)
              }
            })
          }
        },
      })
    },
    timeout(ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    makeToast(variant = null, $content) {
      this.$bvToast.toast($content, {
        title: `${variant || 'default'}`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true,
      })
    },
  },
}
</script>
